<template>
  <ValidationObserver ref="observer" v-slot="{ passes }">
    <form @submit.prevent="passes(nextStep)" novalidate ref="form">
      <h2>{{ currentStep.title }}</h2>
      <div>{{ currentStep.header }}</div>
  
      <div
        v-for="(field, controlindex) in currentStep.fields"
        v-bind:key="controlindex"
      >
        <div class="field" v-if="isDisplayConditionMet(field) && (!field.showCondition && hideRules(field.condition) && !field.hidden)">
          <div class="" v-if="field.type !== 'checkbox' && field.type !== 'check' &&  field.type !== 'hidden'">
            <div class="ql-editor p-0" style="min-height: unset;" v-html="field.label ? field.label : field.name"></div>
          </div>
          <ValidationProvider
            ref="ValidationProviderRef"
            :key="field.name"
            :name="field.name"
            :rules="validationRules(field)"
            v-slot="{ errors, valid }"
            persist
          >

            <div class="control" v-if="field.type === 'text' || field.type === 'email' || field.type === 'number'">
              <!--Name Autocomplete Input-->
              <div ref="autocomplete" class="autocomplete" id="autocomplete" v-if="field.autocomplete">
                  <input 
                    @input="searchAutocomplete"
                    :class="{ invalid: errors[0] }"
                    class="input"
                    v-model="field.value"
                    :name="field.name"
                    :id="field.name"
                    v-bind:autocomplete="isKiosk ? 'abc' : null"
                    :type="field.type"
                    :disabled="field.disabled || false"
                  />
                  <ul
                      id="autocomplete-results"
                      v-show="isOpen"
                      class="autocomplete-results"
                    >
                      <li
                        class="loading"
                        v-if="isLoading"
                      >
                        Loading results...
                      </li>
                      <li
                        v-else
                        v-for="(result, i) in results"
                        :key="i"
                        @click="onAutocompleteItemClick(result)"
                        class="autocomplete-result"
                        v-html="highlightText(result)"
                      >
                      </li>
                    </ul>
                </div>
     <!--Basic Input-->
              <input
              v-if="!field.autocomplete"
                :class="{ invalid: errors[0] }"
                class="input"
                v-model="field.value"
                :name="field.name"
                :id="field.name"
                v-bind:autocomplete="isKiosk ? 'abc' : null"
                :type="field.type"
                :disabled="field.disabled || false"
              />
              <span class="terms" v-if="field.terms">
                <a href="#" @click="openModal($event, field.terms)"
                  >read more</a
                >
                <!-- <p>{{ field.terms }}</p> -->
              </span>
              <span>{{ errors[0] }}</span>
            </div>
            <div class="control" v-if="field.type === 'mobile'">
              <span style="display:none;">{{
                (mobileInputIndex = controlindex)
              }}</span>
              <VuePhoneNumberInput
                :id="field.name"
                :name="field.name"
                ref="mobile"
                v-bind:autocomplete="isKiosk ? 'abc' : null"
                :default-country-code="$parent.countryCode"
                v-model="field.value"
                :state="errors[0] ? false : valid ? true : null"
                :error="errors[0] !== undefined"
                @update="onMobileInputUpdate"
              />
              <span>{{ errors[0] }}</span>
            </div>
            <div class="control" v-if="field.type === 'radio'">
              <RadioInput
                v-if="field.config"
                v-model="field.value"
                :config="field.config"
              />
              <div v-else>
                <div
                  class="option"
                  v-bind:style="{marginBottom: '0.75rem', marginTop: '0.75rem'}"
                  v-for="(option, optionsindex) in field.options"
                  v-bind:key="optionsindex"
                >
                  <input
                    :class="{ invalid: errors[0] }"
                    class="radio"
                    v-model="field.value"
                    :type="field.type"
                    :name="field.name"
                    :id="option.name"
                    :value="option"
                    v-bind:autocomplete="isKiosk ? 'abc' : null"
                    :data-id="option.id"
                    v-on="{
                      ...field.listeners,
                      ...(Boolean((field.listeners || {}).change)
                        ? {
                            change: event =>
                              field.listeners.change(event, field, option)
                          }
                        : {})
                    }"
                  />
                  <label :for="option.name" class="label label--inline">
                    {{ option.name }}
                  </label>
                </div>
              </div>
              <span class="terms" v-if="field.terms">
                <a href="#" @click="openModal($event, field.terms)"
                  >read more</a
                >
                <!-- <p>{{ field.terms }}</p> -->
              </span>
              <span>{{ errors[0] }}</span>
            </div>
            <div class="control" v-if="field.type === 'dropdown'">
              <DropdownInput
                v-if="field.config"
                v-model="field.value"
                :config="field.config"
              />
              <div v-else>
                <div class="dropdown-controls">
                  <select
                    v-bind:style="{marginBottom: '0.75rem', marginTop: '0.75rem', width: '100%', height: '2rem'}"
                    :class="{ invalid: errors[0] }"
                    class="dropdown"
                    v-model="field.value"
                    :type="field.type"
                    :name="field.name"
                    :id="option.name"
                    :value="option"
                    :data-id="option.id"
                    v-on="{
                      ...field.listeners,
                      ...(Boolean((field.listeners || {}).change)
                        ? {
                            change: event =>
                              field.listeners.change(event, field, option)
                          }
                        : {})
                    }"
                  >
                    <template v-for="(control, i) in config.options">
                      <option :value="control.value" :key="i">{{ control.value }}</option>
                    </template>
                  </select>
                </div>
              </div>
              <span class="terms" v-if="field.terms">
                <a href="#" @click="openModal($event, field.terms)"
                  >read more</a
                >
                <!-- <p>{{ field.terms }}</p> -->
              </span>
              <span>{{ errors[0] }}</span>
            </div>
            <div class="control control--checkbox" v-if="field.type === 'checkbox' || field.type === 'check'">
              <!--Checkbox-->
              <input
                :class="{ invalid: errors[0] }"
                class="checkbox"
                v-model="field.CHKvalue"
                type="checkbox"
                :name="field.name"
                :id="field.name"
                v-on:change="fieldChanged(field)"
              />
              <label :for="field.name" class="label label--inline">
                <div
                  class="ql-editor p-0" style="min-height: unset;"
                  v-html="
                    $options.filters.nl2br(
                      field.label ? field.label : field.name
                    )
                  "
                ></div>
                <span class="terms" v-if="field.terms">
                  <a href="#" @click="openModal($event, field.terms)"
                    >read more</a
                  >
                  <!-- <p>{{ field.terms }}</p> -->
                </span>
              </label>
              <span>{{ errors[0] }}</span>
            </div>
            <div class="control" v-if="field.type === 'video'">
              <VideoInput v-model="field.value" :config="field.config" />
              <span class="terms" v-if="field.terms">
                <a href="#" @click="openModal($event, field.terms)"
                  >read more</a
                >
                <!-- <p>{{ field.terms }}</p> -->
              </span>
              <span>{{ errors[0] }}</span>
            </div>
            <div class="control" v-if="field.type === 'html'">
              <vue-editor v-model="field.value" :editor-toolbar="toolbarSetting" />
              <span>{{ errors[0] }}</span>
            </div>
            <!-- <div class="control" v-if="field.type === 'radio'">

              <span>{{ errors[0] }}</span>
            </div> -->
          </ValidationProvider>
        </div>
      </div>
      <div class="control" v-html="currentStep.footer"></div>
      <!--Privacy Statement-->
      <div class="columns is-vcentered">
        <div class="column is-narrow">
          <button
            v-if="hasBack"
            class="button"
            type="button"
            @click="$emit('back')"
          >
            Back
          </button>
        </div>
        <div class="column is-narrow" style="margin-left: auto;">
          <button
            class="appButton button-large button-blue button is-primary margin-bottom"
          >
            <div class="loading"></div>
            {{ hasNext ? 'Next' : 'Submit' }}
          </button>
        </div>
        <div>
          <div ref="signInVideoMirrorContainer">

          </div>
        </div>
      </div>
    </form>


  </ValidationObserver>

</template>

<script>
import axios from 'axios';
import VideoInput from './VideoInput';
import RadioInput from './RadioInput';
import DropdownInput from './DropdownInput';
import EventBus from '../event-bus';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VuePhoneNumberInput,
    VideoInput,
    RadioInput,
    DropdownInput,
  },
  name: 'FormBuilder',
  props: {
    steps: Array,
    callback: Function,
    hasBack: Boolean,
    videoMirror: Object,
    hasNext: Boolean,
    locationCode: String,
    isAsync: {
        type: Boolean,
        required: false,
        default: false,
    }
  },
  computed: {
    isKiosk() {
      return window.location.hostname.includes('kiosk.');
    },
    isLastStep() {
      return this.state.activeStep === this.steps.length - 1;
    }
  },
  data() {
    return {
      mobileInputIndex: null,
      mobileModel: null,
      currentStep: null,
      isOpen: false,
      results: [],
      search: '',
      isLoading: false,
      state: {
        openModal: false,
        isLoading: false,
        activeStep: 0,
        formCompleted: false,
        formCompletedMsg: 'Sorry theres been an error'
      },
      toolbarSetting: [
        ["bold", "italic", "underline", { list: "ordered" }, { list: "bullet" }, "image", "code-block"]
      ]
    };
  },
 /*watch: {
    currentStep: {
      handler(val){
        console.log('asf', val); 
        //this.$emit('input', val);
     },
     deep: true
    }
  },*/
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  created(){
    this.loadCurrentStep();
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    loadCurrentStep(){
      const me  = this;
      me.currentStep = me.steps[me.state.activeStep];//JSON.parse( JSON.stringify( me.steps[me.state.activeStep] ));
    },
    highlightText(text) {
      const searchText = document.getElementById("name").value;
      const regex = new RegExp(searchText, 'gi');
      var name = text.name.replace(/(<strong class="highlightText">|<\/strong>)/gim, '');
      const newText = name.replace(regex, '<strong class="highlightText">$&</strong>');

      const company = text.companyName ? " (" + text.companyName + ")" : "";
      return newText + company;
    },
    handleClickOutside(e) {
      if(e.target?.attributes?.id?.value === 'signInButton') this.resetForm();
      const element = document.getElementById('autocomplete');
      if (e.target !== element && !element.contains(e.target)) {
        this.isOpen = false;
      }
    },
    resetForm(){
      const me = this;
      this.loadCurrentStep();
      //this.$refs.form.reset();
      this.steps[0].fields[0].disabled = false;
      //Reset fields manually
      me.$refs.form['name'].value =  "";
      me.$refs.form['email'].value =  "";
      me.$refs.form['mobile'].value =  "";
      me.$refs.form['companyName'].value = "";
      me.$refs.form['contactId'].value = "";
      this.$refs.observer.reset();
    },
    setResult(result) {
      this.search = result;
      this.isOpen = false;
    },
    onChange(ev) {
      if(ev.target?.value?.length > 1){
        this.isOpen = true;
      }else{
        this.isOpen = false;
      }
    },
    /*
      Optional = 0,
      Required = 2,
      Hidden = 4
    */
    debounce: function(func, wait) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(function() {
        func();
      }, wait);
    },
    searchAutocomplete(ev) {
      const input = ev.target.value;
      var me = this;
      if(input.length > 1){
        me.debounce(function() {
          me.state.isLoading = true;
          var locationId = me.locationCode; //location id
          axios
            .get('/actions/' + locationId, {
              params: {
                search: input
              }
            })
            .then(function(response) {
              console.log('response', response);
              me.isOpen = true;
              me.results = response?.data?.contacts;

              me.state.isLoading = false;
            })
            .catch(function(error) {
              console.log("Error:", error);
              me.state.isLoading = false;
            });
        }, 250);
      }else{
        this.isOpen = false;
      }
    },
    getResultValue(result) {
      return result.title
    }, 

    // Open the selected article in
    // a new window
    onAutocompleteItemClick(result) {
      const me = this;
      console.log('result', result);
      console.log('me.currentStep.fields', me.currentStep.fields);
      me.currentStep.fields[7].hidden = true; //Hide Remember me
      // As long as use auto complete, this is a stored contact
      // which means this contact is not a new contact and is remembered already
      // It safe to set the check value to true and pass it to the BE
      // TODO: This is a hack, need pass the remember me value to the FE from the BE
      me.currentStep.fields[7].CHKvalue = true;
      console.log('me.currentStep.fields[7]', me.currentStep.fields[7]);
      //me.$refs.form.reset()
      me.currentStep.fields.forEach(function(item) {
          if(result[item.name]) {
            if(item.name === "contactId") {
              me.$refs.form[item.name].value= result.id;
              item.value  = result.id;
            }else{
                console.log('result[item.name]', result[item.name]);
                //console.log('me.userData[item.name]', me.userData[item.name]);
                console.log('me.currentStep.fields', me.currentStep.fields);
                me.$refs.form[item.name].value = result[item.name];
                item.value  = result[item.name];
            }

            //me.userData[item.name] = result[item.name];
          }
          //if(result.name) me.currentStep.fields['emai'].value = result.name;
          //if(result.name) item.name = result['name'];


      });
      me.isOpen = false;

      //console.log('me.$refs.ValidationProviderRef', me.$refs.ValidationProviderRef)
      //me.$refs.observer.validate();
      //me.$refs.ValidationProviderRef.validate();
      //me.$validator.validate().then(valid => {
      //});

    },

    validationRules(field) {
      if (field.type === 'html' || field.type === 'content') return '';
      if (field.condition) {
        var selectedContactType = this.steps[0].fields[3].value;
        if (selectedContactType && selectedContactType.rules) {
          // console.log(selectedContactType.rules[field.condition]);
          if (selectedContactType.rules[field.condition] === 2) {
            return 'required';
          }
        }
        return '';
      } else if (field.type === 'video') {
        return {
          watch: field.config
        };
      } else if (field.type === 'mobile') {
        return {
          required: true,
          phonenumber: (this.steps[0].fields[this.mobileInputIndex] || {}).valueObj
        }
      } else {
        return field.rules;
      }
    },
    fieldChanged() {
      this.$forceUpdate();
    },

    isDisplayConditionMet(field) {
      //console.log(field);
      if (typeof field.displayCondition == 'undefined') {
        return true;
      }

      var userData = {};
      this.steps[0].fields.forEach(function(item) {
        userData[item.name] = item.value;
      });

      //console.log('userData', userData);

      var isVisible = function(str){
        try {
          var result = eval("this." + str);
          return result;
        }
        catch(e) {
          return false;
        }
      }.call(userData, field.displayCondition );


      return isVisible;
    },
    hideRules(condition) {
      if (condition) {
        var selectedContactType = this.steps[0].fields[3].value;
        if (selectedContactType && selectedContactType.rules) {
          // console.log(selectedContactType.rules[condition]);
          if (selectedContactType.rules[condition] === 4) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    onMobileInput(payload) {
      this.mobileInputIndex = payload;
      console.log('input', payload);
    },
    onMobileInputUpdate(payload) {
      console.log('payload', payload);
      this.steps[0].fields[this.mobileInputIndex].valueObj = payload;
    },
    onCheckboxUpdate(field) {
      field.value = field.CHKvalue;
    },
    nextStep() {
      if (this.isLastStep) {
        return this.submit();
      }
      console.log(this.$refs.form.email);
      this.state.activeStep++;
    },
    checkCondition() {
      if (
        this.steps[0].fields[3].value.name === 'Contractor' ||
        this.steps[0].fields[3].value.name === 'Visitor'
      ) {
        return true;
      }
    },
    submit() {
      this.callback();
    },
    openModal($event, html) {
      $event.preventDefault();
      EventBus.$emit('OPEN_MODAL', { html });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

  .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    position: absolute;
    top:2.25em;
    left:0;
    z-index: 998;
    margin: 0;
    overflow: auto;
    border-top-color: transparent;
    box-sizing: border-box;
    max-height: 296px;
    overflow: hidden;
    overflow-y: auto;
    background: #fff;
    width:100%;
    list-style: none;
    border: 1px solid #d0d0d0;
    box-shadow: 0 2px 3px rgba(0,0,0,.2);
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    cursor: pointer;
    border-top: 1px solid #ddd;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left:calc(0.625em - 1px);
    padding-right:calc(0.625em - 1px);
    margin:-1px 0 0 0;
    width:100%;
    cursor: pointer;
    background: transparent;
    display: block;
    &:hover{
      background-color: rgba(0, 0, 0, .06);
    }
  }


  strong.highlightText{
    font-weight:bold;
    color:black;
  }




</style>
